import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { ACCOUNT_TYPES, PAGES} from "../../appconstants";
import {
  FlexContainer,
  H1Text,
  Hr,
  Input,
  LabelText,
  LeftBackButtonText,
  Spinner,
  SubmitButton,
  Text
} from "../../design";
import PaymentError from "../../components/paymenterror";
import Header from "./smallscreen/header";
import { ErrorMessage } from "@hookform/error-message";
import Select from "react-select";
import Support from "../../components/support";
import BaseSplitPage from "../../components/splitpage";
import { API } from "../../api";
import { notification } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const postalCodes = require('postal-codes-js');

const RtpBankAccountSetup = (props) => {
  const [errorMsg, setErrorMsg] = useState(null);
  const [isShowSpinner, setShowSpinner] = useState(false);

  const [currentWalletGid, setCurrentWalletGid] = useState(null);

  const {
    control,
    handleSubmit,
    errors,
  } = useForm();

  useEffect(() => {
    getWalletDetails();
  }, []);

  const getWalletDetails = async () => {
    const { data: { entity } } = await API.get(`/rewards/wallet`,
        {
            headers: {
                'RewardsAuthorization': `Bearer ${localStorage.getItem('rtpAccessToken')}`
            },
        }
    );
    if(entity?.gid){
        setCurrentWalletGid(entity?.gid);
    } 
    };

  const customStyles = {
    container: base => ({
      ...base,
      width: '100%',
      height: '41px',
      // marginTop: '8px',
      marginBottom: '8px',
      borderRadius: '10px',
    }),
    control: base => ({
      ...base,
      height: '41px',
      minHeight: '41px',
      border: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
      marginTop: '8px',
      width: '100%'
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
    })
  };

  const customInputStyle = {
    background: 'white',
    // color: 'black',
    borderColor: '#CCCCCC',
    width: '100%',
    height: '41px',
    paddingLeft: '15px',
  };

  const onSubmit = async (data) => {
    const { accountType, accountNumber, accountHolderName, routingNumber } = data;
    const AccountHolderName = accountHolderName.trim();
    const Route = routingNumber.trim();
    const AccountNum = accountNumber.trim();
    
    const finalData = { 
        accountNumber: AccountNum,
        routingNumber: Route,
        accountType: accountType.value === "CURRENT ACCOUNT" ? "CURRENT" : accountType.value,
        name: AccountHolderName,
        walletGid: currentWalletGid,
    };
    setShowSpinner(true);
    try {
        const response = await API.post('/rewards/wallet-bank',
        { ...finalData },
        {
          headers: {
            'RewardsAuthorization': `Bearer ${localStorage.getItem('rtpAccessToken')}`
          },
        }
        );
        if (response?.data.responseCode === 200) {
            props.history.replace(PAGES.RTP_ADDED_BANKS);
            notification.info({
                className: "alert alert-success",
                icon: <div className="d-flex align-items-center gap-8">
                <InfoCircleOutlined style={{ fontSize: '20px' }} />
                <span style={{ fontSize: '15px' }}>Bank successfully added!</span>
                </div>,
                duration: 4,
            })
        }
    } catch (e) {
        setErrorMsg(e && e?.data ? e?.data?.message : 'Unable to process request. Please try again later');
        setShowSpinner(false);
    } finally {
        setShowSpinner(false);
    }
  };

  return (
    <>
    <BaseSplitPage left={
        <>
            <FlexContainer
                flexDirection="column"
                position="relative"
                display="block"
                height="100%"
            >
                <div>
                    <LeftBackButtonText
                        onClick={() => { props.history.push(PAGES.RTP_ADDED_BANKS); }}
                    >
                        Back
                    </LeftBackButtonText>
                    <H1Text>
                        BANK DETAILS SETUP
                    </H1Text>
                </div>
                <div style={{ position: "sticky", top: "85%" }}>
                    <Support email={null}
                        phone={null} />
                </div>
            </FlexContainer>
        </>
        } right={
        <>
        <Header payment={null} />
        <FlexContainer
            className="pt-3 pt-lg-5 w-100 p-2"
            box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
            display="flow-root"
            backgroundColor="#fff"
            borderRadius="10px"
            marginTop="5%"
            marginBottom="5%"
        >
            <H1Text
            className="px-1 px-md-4 mb-0"
            >
             Add Bank Details
            </H1Text>
            <form
            onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(onSubmit)(e);
            }}
            onChange={() => setErrorMsg(null)}
            style={{
                width: '100%',
            }}
            >
            <FlexContainer
                flexDirection="column"
            >
                <div className="px-1 px-md-4 mt-2">
                <Hr />
                <>
                    <LabelText style={{ color: 'black' }}>Account Type</LabelText>
                    <div style={{ width: "299px" }}>
                    <Controller
                        defaultValue={""}
                        color={errors.accountType ? "red" : "inherit"}
                        marginBottom="0px"
                        control={control}
                        name="accountType"
                        placeholder="select"
                        rules={{
                        required: 'Account type is required'
                        }}
                        as={<Select
                        className="px-0 border-0"
                        getOptionLabel={(option) => option.value}
                        styles={customStyles}
                        options={ACCOUNT_TYPES.map(value => { return { value } })} />}
                    />
                    <ErrorMessage
                        errors={errors}
                        name="accountType"
                        render={({ message }) => (
                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                        )}
                    />
                    </div>
                    <LabelText style={{ color: 'black' }}>Account Holder Name</LabelText>
                    <Controller
                        defaultValue={""}
                        color={errors.accountHolderName ? "red" : "inherit"}
                        marginBottom="0px"
                        control={control}
                        name="accountHolderName"
                        placeholder="Enter account holder name"
                        rules={{
                            required: 'This field is required',
                            pattern: {
                            value: /^[a-zA-Z ]+$/,
                            message: 'Bank Holder name must be valid',
                            },
                        }}
                        as={<Input style={customInputStyle}/>}
                    />
                    <ErrorMessage
                        errors={errors}
                        name="accountHolderName"
                        render={({ message }) => (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                        )}
                    />
                    <LabelText style={{ color: 'black' }}>Bank Account Number</LabelText>
                    <Controller
                        defaultValue={""}
                        color={errors.accountNumber ? "red" : "inherit"}
                        marginBottom="0px"
                        control={control}
                        name="accountNumber"
                        placeholder="Enter account number"
                        rules={{
                            required: 'This field is required',
                            pattern: {
                            value: /^\s*[0-9]{6,17}\s*$/,
                            message: 'The account number is invalid',
                            },
                        }}
                        as={<Input style={customInputStyle}/>}
                    />
                    <ErrorMessage
                        errors={errors}
                        name="accountNumber"
                        render={({ message }) => (
                            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                        )}
                    />
                    <LabelText style={{ color: 'black' }}>
                        Routing Number 
                    </LabelText>
                    <Controller
                        defaultValue={""}
                        color={errors.routingNumber ? "red" : "inherit"}
                        marginBottom="0px"
                        control={control}
                        name="routingNumber"
                        placeholder="Enter routing number"
                        rules={{
                        required: 'This field is required',
                        pattern: {
                            value: /^\s*[0-9]{9}\s*$/,
                            message: 'The routing number is invalid',
                        },
                        }}
                        as={<Input style={customInputStyle}/>}
                    />
                    <ErrorMessage
                        errors={errors}
                        name="routingNumber"
                        render={({ message }) => (
                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                        )}
                    />
                </>
                <div style={{ paddingLeft: '0px', paddingTop: '8px' }}>
                    <SubmitButton type="submit" style={{ width: '19rem' }}>Submit</SubmitButton>
                </div>
                <Spinner isOpen={isShowSpinner} />
                {errorMsg && <PaymentError header={'Error Message'} message={errorMsg} />}
                </div>
            </FlexContainer>
            </form>
        </FlexContainer>
        </>
        } 
    />
    </>
  )
};

export default RtpBankAccountSetup;
